module.exports = __webpack_public_path__ + "img/yu.afdf5505.png";